import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: '首页'
      },
      component: () => import('@/views/home/home'),
    },
    {
      path: '/article',
      name: 'article',
      meta: {
        title: '文章列表'
      },
      component: () => import('@/views/article/list')
    },
    {
      path: '/articleDetail',
      name: 'articleDetail',
      meta: {
        title: '文章详情'
      },
      component: () => import('@/views/article/detail')
    },
    {
      path: '/login',
      name: 'login',
      hidden: true,
      meta: {
        mode: 'sub',
        title: '登录注册',
        navColor: '#A91728',
        bgColor: '#A91728',
        bgImg: '',
        subBgColor: '#980028',
      },
      component: () => import('@/views/auth/login'),
    },
    {
      path: '/user',
      name: 'user',
      hidden: true,
      meta: {
        mode: 'sub',
        title: '个人中心',
        navColor: '#A91728',
        bgColor: '#A91728',
        bgImg: '',
        subBgColor: '#980028',
      },
      component: () => import('@/views/user/index'),
    },
    {
      path: '/noticeDetail',
      name: 'noticeDetail',
      meta: {
        title: '消息详情',
        pname: '',
        mode: 'sub',
        navColor: '#1348A4',
        bgColor: '#1348A4',
        subBgColor: '#043A97',
      },
      component: () => import('@/views/user/NoticeDetail'),
    },
    {
      path: '/examSearch',
      name: 'examSearch',
      meta: {
        title: '试题',
        pname: '',
        mode: 'sub',
        navColor: '#1348A4',
        bgColor: '#1348A4',
        subBgColor: '#043A97',
      },
      component: () => import('@/views/exam/index'),
      children: [
        {
          path: 'list',
          name: 'examSearchList',
          meta: {
            title: '试题列表',
            pname: 'examSearch',
            mode: 'sub',
            navColor: '#1348A4',
            bgColor: '#1348A4',
            subBgColor: '#043A97',
          },
          component: () => import('@/views/exam/list'),
        },
        {
          path: 'detail',
          name: 'examSearchDetail',
          meta: {
            title: '试题详情',
            pname: 'examSearch',
            mode: 'sub',
            navColor: '#1348A4',
            bgColor: '#1348A4',
            subBgColor: '#043A97',
          },
          component: () => import('@/views/exam/detail'),
        },
        {
          path: 'recordDetail',
          name: 'examSearchRecordDetail',
          meta: {
            title: '考试记录',
            pname: 'examSearch',
            mode: 'sub',
            navColor: '#1348A4',
            bgColor: '#1348A4',
            subBgColor: '#043A97',
          },
          component: () => import('@/views/exam/recordDetail'),
        },
      ]
    },
    {
      path: '/lawer',
      name: 'lawer',
      hidden: true,
      meta: {
        title: '',
      },
      component: () => import('@/views/lawer/Index'),
      children: [
        {
          path: 'policy',
          name: 'policy',
          meta: {
            title: '练习中心',
            pname: 'lawer',
            mode: 'sub',
            navColor: '#1348A4',
            bgColor: '#1348A4',
            subBgColor: '#043A97',
          },
          component: () => import('@/views/lawer/Policy'),
        },
        {
          path: 'exam',
          name: 'exam',
          meta: {
            title: '考试中心',
            pname: 'lawer',
            mode: 'sub',
            navColor: '#1348A4',
            bgColor: '#1348A4',
            subBgColor: '#043A97',
          },
          component: () => import('@/views/lawer/Exam'),
        },
        {
          path: 'help',
          name: 'help',
          meta: {
            title: '法律援助',
            pname: 'lawer',
            mode: 'sub',
            navColor: '#1348A4',
            bgColor: '#1348A4',
            subBgColor: '#043A97',
          },
          component: () => import('@/views/lawer/Help'),
        },
        {
          path: 'course',
          name: 'course',
          meta: {
            title: '课程中心',
            pname: 'lawer',
            mode: 'sub',
            navColor: '#1348A4',
            bgColor: '#1348A4',
            subBgColor: '#043A97',
          },
          component: () => import('@/views/lawer/Course'),
        },
        {
          path: 'courseDetail',
          name: 'courseDetail',
          hidden: true,
          meta: {
            title: '课程详情',
            pname: 'lawer',
            mode: 'sub',
            navColor: '#1348A4',
            bgColor: '#1348A4',
            subBgColor: '#043A97',
          },
          component: () => import('@/views/lawer/CourseDetail'),
        },
      ]
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js